function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import debounce from 'lodash.debounce';
import PropTypes from 'prop-types';
import { useLocale } from '@adsk/alloy-react-helpers';
import { defaultSelectBoxRenderer } from '../layout/defaultRenderers';
import SelectBox from '../SelectBox';
/**
 * AsyncSelectBox, extends [SelectBox](selectbox) to add async data support
 */

var AsyncSelectBox = /*#__PURE__*/function (_React$Component) {
  _inherits(AsyncSelectBox, _React$Component);

  var _super = _createSuper(AsyncSelectBox);

  function AsyncSelectBox(props) {
    var _this;

    _classCallCheck(this, AsyncSelectBox);

    _this = _super.call(this, props);
    _this.state = {
      isLoading: false,
      isLoadingValue: false,
      defaultValue: _this.props.defaultValue,
      options: _this.props.options
    };
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.handleCreate = _this.handleCreate.bind(_assertThisInitialized(_this));
    _this.handleOpen = _this.handleOpen.bind(_assertThisInitialized(_this));
    _this.loadOptionsDebounced = debounce(_this.loadOptions, props.inputDebounce);
    _this._mounted = false;
    _this._cache = {};
    return _this;
  }

  _createClass(AsyncSelectBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._mounted = true;
      var _this$props = this.props,
          options = _this$props.options,
          autoLoad = _this$props.autoLoad,
          loadDefaultValue = _this$props.loadDefaultValue;

      if (loadDefaultValue) {
        this.loadDefaultValue();
      }

      if (options.length === 0 && autoLoad) {
        this.loadOptions('');
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._mounted = false;
      this._callback = null;
      this.loadOptionsDebounced.cancel();
    }
  }, {
    key: "loadDefaultValue",
    value: function loadDefaultValue() {
      var _this2 = this;

      var loadDefaultValue = this.props.loadDefaultValue;

      var callback = function callback(error, data) {
        if (!_this2._mounted) return;

        _this2.setState({
          isLoadingValue: false,
          defaultValue: data
        });
      };

      loadDefaultValue().then(function (data) {
        return callback(null, data);
      }).catch(function (error) {
        return callback(error);
      });
      this.setState({
        isLoadingValue: true
      });
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(inputValue) {
      var _this3 = this;

      var loadOptions = this.props.loadOptions;

      var callback = function callback(error, data) {
        if (!_this3._mounted) return;
        var options = Array.isArray(data) ? data : [];
        _this3._cache[inputValue] = options;

        if (callback === _this3._callback) {
          _this3._callback = null;

          _this3.setState({
            isLoading: false,
            options: options
          });
        }
      }; // Ignore all but the most recent request


      this._callback = callback;
      loadOptions(inputValue).then(function (data) {
        return callback(null, data);
      }).catch(function (error) {
        return callback(error);
      });
    }
  }, {
    key: "getOptions",
    value: function getOptions(inputValue) {
      if (this._cache[inputValue]) {
        this._callback = null;
        this.setState({
          isLoading: false,
          options: this._cache[inputValue]
        });
        return;
      }

      if (!this.state.isLoading) {
        this.setState({
          isLoading: true
        });
      }

      this.props.inputDebounce ? this.loadOptionsDebounced(inputValue) : this.loadOptions(inputValue);
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(inputValue) {
      var _this$props2 = this.props,
          ignoreCase = _this$props2.ignoreCase,
          onInputChange = _this$props2.onInputChange;
      onInputChange && onInputChange(inputValue);
      this.getOptions(ignoreCase ? inputValue.toLowerCase() : inputValue);
    }
  }, {
    key: "handleCreate",
    value: function handleCreate(inputValue, stateAndHelpers) {
      var _this$props3 = this.props,
          valueKey = _this$props3.valueKey,
          labelKey = _this$props3.labelKey,
          onCreate = _this$props3.onCreate,
          ignoreCase = _this$props3.ignoreCase;
      var cache = this._cache[ignoreCase ? inputValue.toLowerCase() : inputValue];

      if (Array.isArray(cache)) {
        var _cache$unshift;

        cache.unshift((_cache$unshift = {}, _defineProperty(_cache$unshift, valueKey, inputValue), _defineProperty(_cache$unshift, labelKey, inputValue), _cache$unshift));
      }

      onCreate(inputValue, stateAndHelpers);
    }
  }, {
    key: "handleOpen",
    value: function handleOpen() {
      var _this$props4;

      this.getOptions('');

      if ((_this$props4 = this.props) !== null && _this$props4 !== void 0 && _this$props4.onOpen) {
        this.props.onOpen();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          children = _this$props5.children,
          placeholder = _this$props5.placeholder,
          searchPlaceholder = _this$props5.searchPlaceholder;
      var _this$state = this.state,
          _isLoading = _this$state.isLoading,
          isLoadingValue = _this$state.isLoadingValue,
          options = _this$state.options,
          defaultValue = _this$state.defaultValue;
      var loadingPlaceholder = this.props.loadingPlaceholder || this.props['T'].translate('LOADING');
      var isLoading = _isLoading || isLoadingValue;
      return children(_objectSpread(_objectSpread({}, this.props), {}, {
        key: isLoadingValue,
        isLoading: isLoading,
        defaultValue: defaultValue,
        onInputChange: this.handleInputChange,
        onCreate: this.handleCreate,
        onOpen: this.handleOpen,
        placeholder: isLoading ? loadingPlaceholder : placeholder,
        searchPlaceholder: isLoading ? loadingPlaceholder : searchPlaceholder,
        options: isLoading ? [] : options
      }));
    }
  }]);

  return AsyncSelectBox;
}(React.Component);

AsyncSelectBox.defaultProps = _objectSpread(_objectSpread({}, SelectBox.defaultProps), {}, {
  children: defaultSelectBoxRenderer,
  inputDebounce: 250,
  autoLoad: true,
  ignoreCase: true,
  options: [],
  onCreate: function onCreate() {}
});
AsyncSelectBox.propTypes = _objectSpread(_objectSpread({}, SelectBox.propTypes), {}, {
  /**
   * render function
   */
  children: PropTypes.func.isRequired,

  /**
   * input change debounce in millisecond
   */
  inputDebounce: PropTypes.number,

  /**
   * `(inputValue) => Promise(array)`, aysnc load options
   */
  loadOptions: PropTypes.func.isRequired,

  /**
   * `() => Promise(array | object)`, aysnc load defaultValue
   */
  loadDefaultValue: PropTypes.func,

  /**
   * placeholder when loading
   */
  loadingPlaceholder: PropTypes.node,

  /**
   * whether to load options on mount
   */
  autoLoad: PropTypes.bool,

  /**
   * whether to ignore case when loading options
   */
  ignoreCase: PropTypes.bool
});

var WrapperAsyncSelectBox = function WrapperAsyncSelectBox(props) {
  var _useLocale = useLocale(function (_ref) {
    var locale = _ref.locale;
    return require("../i18n/".concat(locale, ".json"));
  }),
      T = _useLocale.T;

  return /*#__PURE__*/React.createElement(AsyncSelectBox, _extends({}, props, {
    T: T
  }));
};

export default WrapperAsyncSelectBox;
//# sourceMappingURL=AsyncSelectBox.js.map